module.exports = "<svg height=\"0.65em\" width=\"0.65em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"><path d=\"M505.94 6.06c-8.07-8.08-21.17-8.08-29.25 0L6.05 476.7c-8.08 8.07-8.08 21.16 0 29.24 4.04 4.04 9.33 6.06 14.62 6.06 5.3 0 10.6-2.02 14.63-6.06L505.95 35.3c8.08-8.07 8.08-21.16 0-29.24z\"/><path d=\"M505.94 476.7L35.3 6.05c-8.07-8.08-21.17-8.08-29.24 0-8.08 8.08-8.08 21.17 0 29.25L476.7 505.95c4.03 4.04 9.33 6.06 14.62 6.06 5.3 0 10.6-2.02 14.62-6.06 8.08-8.07 8.08-21.17 0-29.25z\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/close-small.svg
// module id = ./src/icons/close-small.svg
// module chunks = 21